import React from "react";
import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@mui/material";
import { canadaGibsonFont } from "../Config";

export default function RHFCheckbox({ name, label, control, defaultValue = false, ...muiProps }) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={(field) => (
                <FormControlLabel
                    sx={{
                        "& .MuiFormControlLabel-label": {
                            textDecoration: "none",
                            fontWeight:"lighter",
                            ...canadaGibsonFont
                        },
                    }}
                    control={
                        <Checkbox
                            {...field}
                            checked={!!field.value}
                            onChange={(e, checked) => {
                                field.onChange(checked);
                            }}
                            {...muiProps}
                        />
                    }
                    label={label}
                />
            )}
        />
    );
}
